import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalError } from '@rsos/components/capstone/RolesShared/Common/ModalInserts';
import { Box, Text, Button, Modal } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';
import { deleteAppRole, selectUserOrgByApp } from '@rsos/sinatra';
import { notifySuccess, notifyError } from '@rsos/utils/toastUtils';
import { BasePrimaryText } from '../common.styles';

const initialRequestStatus = {
  loading: false,
  idle: true,
  error: null,
};

const DeleteRoleModal = ({ isOpened, role, onClose }) => {
  const [requestStatus, setRequestStatus] = useState(initialRequestStatus);

  const sinatra = useSelector(state => state.sinatra);
  const dispatch = useDispatch();
  const { application } = sinatra.user.currentRole;
  const org = selectUserOrgByApp(sinatra, application);
  const handleDelete = () => {
    setRequestStatus({ loading: true, idle: false, error: null });
    dispatch(deleteAppRole(org.id, application, { id: role.id }))
      .then(() => {
        setRequestStatus({ loading: false, idle: true, error: null });
        notifySuccess('Role deleted.');
        onClose();
      })
      .catch(e => {
        const error =
          e.error?.response?.data?.detail ||
          e.error?.message ||
          'There was an error';
        notifyError(error);
        setRequestStatus({ loading: false, idle: false, error: error });
      });
  };
  const handleTryAgain = () => {
    setRequestStatus(initialRequestStatus);
  };
  const handleClose = () => {
    setRequestStatus(initialRequestStatus);
    onClose();
  };
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={400}
      id="modal-delete-role"
    >
      {requestStatus.error ? (
        <ModalError
          onClick={handleTryAgain}
          error={requestStatus.error}
          onClose={handleClose}
        />
      ) : (
        <>
          <ModalHeader onClose={onClose}>
            <Box width={400}>
              <Text size="xlarge" fontWeight="bold" color="primaryText">
                Delete Role
              </Text>
            </Box>
          </ModalHeader>
          <ModalBody>
            <BasePrimaryText>
              Are you sure? This role will no longer exist once removed.
            </BasePrimaryText>
          </ModalBody>
          <ModalFooter flow={12}>
            <Button btnType="tertiary" onClick={onClose} grow noMargin>
              Cancel
            </Button>
            <Button
              btnType="warning_tertiary"
              onClick={handleDelete}
              isLoadingProp={requestStatus.loading}
              grow
              noMargin
            >
              Delete
            </Button>
          </ModalFooter>
        </>
      )}
    </Modal>
  );
};

export default DeleteRoleModal;
